import axios from "axios";

export const apiLogout = async () => {
    return axios.get('api/Logout/Logout')
}
